export default __webpack_public_path__ + "static/media/shop.ba379c84.svg";